import styled from 'styled-components'

export const WelcomeTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
`
